import React from 'react';
import RequiredMission from '../components/RequiredMission';

const RequiredMissionPage = () => {
	return <RequiredMission />;
};

export default RequiredMissionPage;
